import { useEffect, useState } from 'react'

import { ConnectorDeviceProfile } from '@/constants/medconnect-devices-types'
import { getDeviceProfiles } from '@/core/classes/MedconnectDevicesAPI'

/**
 * The device catalogue served by the connector, or an empty list while loading / unreachable.
 * Loaded once the connector answers and again after each restart (`connectorGeneration`, see useConnectorGeneration).
 */
export function useDeviceProfiles(connectorGeneration: number): { profiles: ConnectorDeviceProfile[]; isLoading: boolean } {
  const [profiles, setProfiles] = useState<ConnectorDeviceProfile[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (connectorGeneration === 0) return
    let cancelled = false
    getDeviceProfiles()
      .then((result) => {
        if (!cancelled) setProfiles(result)
      })
      .catch(() => {
        if (!cancelled) setProfiles([])
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [connectorGeneration])

  return { profiles, isLoading }
}
